import React, { Component } from 'react';
import Helmet from 'react-helmet';
import {
  Link,
} from 'react-router-dom';

import AuthService from './AuthService';
import AuthModalContext from '../contexts/AuthModalContext';

class SharingDescription extends Component {
  static contextType = AuthModalContext;
  constructor() {
    super();
    this.Auth = new AuthService();
    this.toSignUp = this.toSignUp.bind(this);
    this._onThemeChanged = () => this.forceUpdate();
  }

  componentDidMount() {
    window.addEventListener('themeChanged', this._onThemeChanged);
  }

  componentWillUnmount() {
    window.removeEventListener('themeChanged', this._onThemeChanged);
  }

  toSignUp() {
    this.context.openAuthModal('signup');
  }

  render() {
    var isLoggedIn = this.Auth.getToken();
    var isDark = document.documentElement.classList.contains('tw-dark');

    var pageBg = isDark ? '#0a0a0a' : '#fafafa';
    var cardBg = isDark ? '#1a1a1a' : 'white';
    var cardBorder = isDark ? '#2a2a2a' : '#e8e8e8';
    var headingColor = isDark ? '#fff' : '#1a1a1a';
    var textColor = isDark ? '#aaa' : '#666';
    var mutedText = isDark ? '#888' : '#888';
    var dividerColor = isDark ? '#2a2a2a' : '#f0f0f0';
    var infoBg = isDark ? '#111' : '#f9f9f9';

    return (
      <div style={{ minHeight: '100vh', backgroundColor: pageBg, paddingTop: '80px' }}>
        <Helmet>
          <title>Share & Earn | Primal Marketplace</title>
          <meta name="description" content="Share listings on Primal Marketplace and earn a commission on every sale made through your link. Minimum $1.00 per sale." />
          <meta property="og:title" content="Share & Earn | Primal Marketplace" />
          <meta property="og:description" content="Share listings on Primal Marketplace and earn a commission on every sale made through your link. Minimum $1.00 per sale." />
        </Helmet>

        {/* Hero Section */}
        <div style={{ textAlign: 'center', padding: '60px 20px 40px', maxWidth: '700px', margin: '0 auto' }}>
          <h1 style={{ fontSize: '36px', fontWeight: '800', color: headingColor, marginBottom: '16px', lineHeight: 1.2 }}>
            Share & Earn on Primal Marketplace
          </h1>
          <p style={{ fontSize: '18px', color: textColor, lineHeight: 1.6, marginBottom: '32px' }}>
            Share listings you love with friends and followers. When someone buys through your link, you earn a commission. It's that simple.
          </p>
          {isLoggedIn ? (
            <Link
              to="/browse"
              style={{
                display: 'inline-block', backgroundColor: '#c9a84c', color: 'white',
                padding: '14px 40px', borderRadius: '8px', fontSize: '16px',
                fontWeight: 'bold', textDecoration: 'none',
              }}
            >
              Start Sharing
            </Link>
          ) : (
            <button
              onClick={this.toSignUp}
              style={{
                backgroundColor: '#c9a84c', color: 'white',
                padding: '14px 40px', borderRadius: '8px', fontSize: '16px',
                fontWeight: 'bold', border: 'none', cursor: 'pointer',
              }}
            >
              Get Started
            </button>
          )}
        </div>

        {/* 3-Step Visual */}
        <div style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 20px' }}>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap' }}>
            {/* Step 1 */}
            <div style={{
              flex: '1 1 220px', maxWidth: '240px', backgroundColor: cardBg,
              borderRadius: '16px', padding: '32px 24px', textAlign: 'center',
              boxShadow: isDark ? 'none' : '0 2px 12px rgba(0,0,0,0.06)', border: '1px solid ' + cardBorder,
            }}>
              <div style={{
                width: '56px', height: '56px', borderRadius: '50%',
                backgroundColor: 'rgba(201,168,76,0.1)', display: 'flex',
                alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px',
                fontSize: '24px', color: '#c9a84c',
              }}>
                <i className="fa fa-share-alt" />
              </div>
              <h3 style={{ fontSize: '18px', fontWeight: '700', color: headingColor, marginBottom: '8px' }}>1. Share</h3>
              <p style={{ fontSize: '14px', color: mutedText, lineHeight: 1.5, margin: 0 }}>
                Find a listing you like and tap "Share & Earn" to get your unique referral link.
              </p>
            </div>

            {/* Step 2 */}
            <div style={{
              flex: '1 1 220px', maxWidth: '240px', backgroundColor: cardBg,
              borderRadius: '16px', padding: '32px 24px', textAlign: 'center',
              boxShadow: isDark ? 'none' : '0 2px 12px rgba(0,0,0,0.06)', border: '1px solid ' + cardBorder,
            }}>
              <div style={{
                width: '56px', height: '56px', borderRadius: '50%',
                backgroundColor: 'rgba(201,168,76,0.1)', display: 'flex',
                alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px',
                fontSize: '24px', color: '#c9a84c',
              }}>
                <i className="fa fa-shopping-cart" />
              </div>
              <h3 style={{ fontSize: '18px', fontWeight: '700', color: headingColor, marginBottom: '8px' }}>2. Someone Buys</h3>
              <p style={{ fontSize: '14px', color: mutedText, lineHeight: 1.5, margin: 0 }}>
                When someone clicks your link and makes a purchase, the sale is tracked to you.
              </p>
            </div>

            {/* Step 3 */}
            <div style={{
              flex: '1 1 220px', maxWidth: '240px', backgroundColor: cardBg,
              borderRadius: '16px', padding: '32px 24px', textAlign: 'center',
              boxShadow: isDark ? 'none' : '0 2px 12px rgba(0,0,0,0.06)', border: '1px solid ' + cardBorder,
            }}>
              <div style={{
                width: '56px', height: '56px', borderRadius: '50%',
                backgroundColor: 'rgba(22,163,74,0.1)', display: 'flex',
                alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px',
                fontSize: '24px', color: '#16a34a',
              }}>
                <i className="fa fa-money" />
              </div>
              <h3 style={{ fontSize: '18px', fontWeight: '700', color: headingColor, marginBottom: '8px' }}>3. You Earn</h3>
              <p style={{ fontSize: '14px', color: mutedText, lineHeight: 1.5, margin: 0 }}>
                Sellers set the commission — a flat dollar amount (minimum $1.00). Commissions are added to your balance and can be withdrawn anytime.
              </p>
            </div>
          </div>
        </div>

        {/* Commission Breakdown */}
        <div style={{ maxWidth: '600px', margin: '20px auto', padding: '0 20px' }}>
          <div style={{
            backgroundColor: cardBg, borderRadius: '16px', padding: '32px',
            boxShadow: isDark ? 'none' : '0 2px 12px rgba(0,0,0,0.06)', border: '1px solid ' + cardBorder,
          }}>
            <h2 style={{ fontSize: '22px', fontWeight: '700', color: headingColor, textAlign: 'center', marginBottom: '24px' }}>
              Commission Breakdown
            </h2>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '32px', flexWrap: 'wrap', marginBottom: '24px' }}>
              <div style={{ textAlign: 'center' }}>
                <div style={{
                  width: '80px', height: '80px', borderRadius: '50%',
                  border: '3px solid #c9a84c', display: 'flex',
                  alignItems: 'center', justifyContent: 'center', margin: '0 auto 8px',
                }}>
                  <span style={{ fontSize: '24px', fontWeight: '800', color: '#c9a84c' }}>$0</span>
                </div>
                <p style={{ fontSize: '13px', color: mutedText, fontWeight: '600', margin: 0 }}>Listing Fees</p>
              </div>
              <div style={{ textAlign: 'center' }}>
                <div style={{
                  width: '80px', height: '80px', borderRadius: '50%',
                  border: '3px solid #16a34a', display: 'flex', flexDirection: 'column',
                  alignItems: 'center', justifyContent: 'center', margin: '0 auto 8px',
                }}>
                  <span style={{ fontSize: '24px', fontWeight: '800', color: '#16a34a', lineHeight: 1 }}>$1+</span>
                </div>
                <p style={{ fontSize: '13px', color: mutedText, fontWeight: '600', margin: 0 }}>Your Commission</p>
              </div>
            </div>
            <div style={{ backgroundColor: infoBg, borderRadius: '10px', padding: '16px 20px' }}>
              <p style={{ fontSize: '14px', color: textColor, lineHeight: 1.6, margin: 0, textAlign: 'center' }}>
                Sellers set a flat dollar commission on each listing (minimum $1.00). Commissions are credited to your balance after the buyer confirms receipt or the 14-day auto-release period ends. You can withdraw your balance anytime from your settings page.
              </p>
            </div>
          </div>
        </div>

        {/* How It Works for Sellers */}
        <div style={{ maxWidth: '600px', margin: '32px auto', padding: '0 20px' }}>
          <div style={{
            backgroundColor: cardBg, borderRadius: '16px', padding: '32px',
            boxShadow: isDark ? 'none' : '0 2px 12px rgba(0,0,0,0.06)', border: '1px solid ' + cardBorder,
          }}>
            <h2 style={{ fontSize: '22px', fontWeight: '700', color: headingColor, textAlign: 'center', marginBottom: '24px' }}>
              How It Works for Sellers
            </h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '20px' }}>
              <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                <div style={{
                  width: '36px', height: '36px', borderRadius: '50%', flexShrink: 0,
                  backgroundColor: 'rgba(201,168,76,0.1)', display: 'flex',
                  alignItems: 'center', justifyContent: 'center',
                  fontSize: '16px', color: '#c9a84c',
                }}>
                  <i className="fa fa-sliders" />
                </div>
                <div>
                  <p style={{ fontSize: '14px', fontWeight: '600', color: headingColor, margin: '0 0 4px' }}>Set Your Commission</p>
                  <p style={{ fontSize: '13px', color: mutedText, lineHeight: 1.4, margin: 0 }}>Set a flat dollar commission per listing (minimum $1.00). You decide what each referral is worth.</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                <div style={{
                  width: '36px', height: '36px', borderRadius: '50%', flexShrink: 0,
                  backgroundColor: 'rgba(201,168,76,0.1)', display: 'flex',
                  alignItems: 'center', justifyContent: 'center',
                  fontSize: '16px', color: '#c9a84c',
                }}>
                  <i className="fa fa-toggle-on" />
                </div>
                <div>
                  <p style={{ fontSize: '14px', fontWeight: '600', color: headingColor, margin: '0 0 4px' }}>Enable or Disable</p>
                  <p style={{ fontSize: '13px', color: mutedText, lineHeight: 1.4, margin: 0 }}>Toggle sharing on or off for each listing. Available on items priced $10 and above.</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                <div style={{
                  width: '36px', height: '36px', borderRadius: '50%', flexShrink: 0,
                  backgroundColor: 'rgba(201,168,76,0.1)', display: 'flex',
                  alignItems: 'center', justifyContent: 'center',
                  fontSize: '16px', color: '#c9a84c',
                }}>
                  <i className="fa fa-bullhorn" />
                </div>
                <div>
                  <p style={{ fontSize: '14px', fontWeight: '600', color: headingColor, margin: '0 0 4px' }}>Get More Exposure</p>
                  <p style={{ fontSize: '13px', color: mutedText, lineHeight: 1.4, margin: 0 }}>Other users promote your listings for you — you only pay commission on actual sales.</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                <div style={{
                  width: '36px', height: '36px', borderRadius: '50%', flexShrink: 0,
                  backgroundColor: 'rgba(201,168,76,0.1)', display: 'flex',
                  alignItems: 'center', justifyContent: 'center',
                  fontSize: '16px', color: '#c9a84c',
                }}>
                  <i className="fa fa-dollar" />
                </div>
                <div>
                  <p style={{ fontSize: '14px', fontWeight: '600', color: headingColor, margin: '0 0 4px' }}>Predictable Cost</p>
                  <p style={{ fontSize: '13px', color: mutedText, lineHeight: 1.4, margin: 0 }}>Commission is a flat dollar amount — no surprises. You know exactly what each referral costs.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Good to Know */}
        <div style={{ maxWidth: '600px', margin: '32px auto', padding: '0 20px' }}>
          <div style={{
            backgroundColor: cardBg, borderRadius: '16px', padding: '32px',
            boxShadow: isDark ? 'none' : '0 2px 12px rgba(0,0,0,0.06)', border: '1px solid ' + cardBorder,
          }}>
            <h2 style={{ fontSize: '22px', fontWeight: '700', color: headingColor, textAlign: 'center', marginBottom: '24px' }}>
              Good to Know
            </h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              {[
                { icon: 'fa-tag', text: 'Listings must be priced at $10 or more to be eligible for Share & Earn.' },
                { icon: 'fa-clock-o', text: 'Your share link tracks the referral for 7 days. If the buyer purchases within that window, you get credit.' },
                { icon: 'fa-ban', text: "You can't earn commission on your own purchases — self-referrals are automatically excluded." },
                { icon: 'fa-info-circle', text: 'The minimum commission is $1.00 per sale. Sellers set the amount when creating a listing.' },
                { icon: 'fa-calculator', text: 'Commission is calculated on the item price only — shipping costs are not included.' },
                { icon: 'fa-shield', text: 'Commissions are credited to your balance after the buyer confirms receipt or 14-day auto-release. Withdraw anytime from Settings > Payments.' },
              ].map(function(item, i) {
                return (
                  <div key={i} style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                    <i className={'fa ' + item.icon} style={{ color: '#c9a84c', fontSize: '16px', marginTop: '2px', width: '20px', textAlign: 'center', flexShrink: 0 }} />
                    <p style={{ fontSize: '14px', color: textColor, lineHeight: 1.5, margin: 0 }}>{item.text}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <div style={{ maxWidth: '600px', margin: '40px auto', padding: '0 20px 60px' }}>
          <h2 style={{ fontSize: '22px', fontWeight: '700', color: headingColor, textAlign: 'center', marginBottom: '24px' }}>
            Frequently Asked Questions
          </h2>
          <div style={{
            backgroundColor: cardBg, borderRadius: '16px', overflow: 'hidden',
            boxShadow: isDark ? 'none' : '0 2px 12px rgba(0,0,0,0.06)', border: '1px solid ' + cardBorder,
          }}>
            <div style={{ padding: '20px 24px', borderBottom: '1px solid ' + dividerColor }}>
              <h4 style={{ fontSize: '15px', fontWeight: '700', color: headingColor, marginBottom: '6px' }}>How do I get paid?</h4>
              <p style={{ fontSize: '14px', color: mutedText, lineHeight: 1.5, margin: 0 }}>
                When a sale completes (buyer confirms receipt or 14-day auto-release), the commission is added to your Share & Earn balance. You can withdraw your balance anytime from <Link to="/settings?tab=payments" style={{ color: '#c9a84c', fontWeight: '600' }}>Settings &gt; Payments</Link>. A small $0.25 withdrawal fee applies, so you can let commissions build up before withdrawing.
              </p>
            </div>
            <div style={{ padding: '20px 24px', borderBottom: '1px solid ' + dividerColor }}>
              <h4 style={{ fontSize: '15px', fontWeight: '700', color: headingColor, marginBottom: '6px' }}>Can I share any listing?</h4>
              <p style={{ fontSize: '14px', color: mutedText, lineHeight: 1.5, margin: 0 }}>
                You can share any active listing that has Share & Earn enabled by the seller and is priced at $10 or more. Most listings have sharing enabled by default. Look for the "Share & Earn" button on the product page.
              </p>
            </div>
            <div style={{ padding: '20px 24px', borderBottom: '1px solid ' + dividerColor }}>
              <h4 style={{ fontSize: '15px', fontWeight: '700', color: headingColor, marginBottom: '6px' }}>How is the commission calculated?</h4>
              <p style={{ fontSize: '14px', color: mutedText, lineHeight: 1.5, margin: 0 }}>
                The seller sets a flat dollar commission for each listing (minimum $1.00). The commission is deducted from the seller's earnings (item price only, shipping is not included). Only listings priced at $10 or above are eligible for Share & Earn.
              </p>
            </div>
            <div style={{ padding: '20px 24px', borderBottom: '1px solid ' + dividerColor }}>
              <h4 style={{ fontSize: '15px', fontWeight: '700', color: headingColor, marginBottom: '6px' }}>How long does my share link last?</h4>
              <p style={{ fontSize: '14px', color: mutedText, lineHeight: 1.5, margin: 0 }}>
                Your referral link tracks the buyer for 7 days. If they click your link and purchase the item within that window, you'll receive credit for the sale.
              </p>
            </div>
            <div style={{ padding: '20px 24px', borderBottom: '1px solid ' + dividerColor }}>
              <h4 style={{ fontSize: '15px', fontWeight: '700', color: headingColor, marginBottom: '6px' }}>Where can I see my earnings?</h4>
              <p style={{ fontSize: '14px', color: mutedText, lineHeight: 1.5, margin: 0 }}>
                Your commission balance is shown in <Link to="/settings?tab=payments" style={{ color: '#c9a84c', fontWeight: '600' }}>Settings &gt; Payments</Link> under "Share &amp; Earn Commissions." You can also view individual referral sales on your <Link to="/orders" style={{ color: '#c9a84c', fontWeight: '600' }}>Orders page</Link> Earnings tab.
              </p>
            </div>
            <div style={{ padding: '20px 24px' }}>
              <h4 style={{ fontSize: '15px', fontWeight: '700', color: headingColor, marginBottom: '6px' }}>What happens if the buyer requests a refund?</h4>
              <p style={{ fontSize: '14px', color: mutedText, lineHeight: 1.5, margin: 0 }}>
                If a sale is refunded, the commission is returned as well. This protects both buyers and sellers.
              </p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div style={{ textAlign: 'center', padding: '20px', borderTop: '1px solid ' + cardBorder }}>
          <Link to="/" style={{ fontSize: '13px', color: '#999', textDecoration: 'none', marginRight: '20px' }}>
            Primal Marketplace
          </Link>
          <Link to="/terms" style={{ fontSize: '13px', color: '#999', textDecoration: 'none' }}>
            Terms
          </Link>
        </div>
      </div>
    );
  }
}

export default SharingDescription;
